import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/app/App';
import './index.css';
import { createBrowserRouter, redirect, RouterProvider } from 'react-router-dom';
import './locale/i18n';
import { ThemeContext } from './contexts/ThemeContext.tsx';
import { PaletteMode, ThemeProvider } from '@mui/material';
import RTL from './components/app/RTL.tsx';
import useProjectTheme from './theme/index.tsx';
import palettes from './theme/colors.json';
import Dashboard from './components/dashboard/Dashboard.tsx';
import Help from './components/help/Help.tsx';
import Studio, { studioLoader } from './components/studio/Studio.tsx';
import TicketsList from './components/support/TicketsList.tsx';
import Auth from './components/auth/Auth.tsx';
import Login from './components/auth/Login.tsx';
import Register from './components/auth/Register.tsx';
import ResetPassword from './components/auth/@recover-password/RecoverPassword.tsx';
import ConfirmCode from './components/auth/@recover-password/ConfirmCode.tsx';
import NewPassword from './components/auth/@recover-password/NewPassword.tsx';
import ManageCampaign from './components/campaigns/ManageCampaign.tsx';
import CreateCampaign from './components/campaigns/CreateCampaign.tsx';
import ViewCampaign from './components/campaigns/ViewCampaign.tsx';
import { LocalizationProvider } from '@mui/x-date-pickers';
import * as Sentry from '@sentry/react';
import { version } from '../package.json';
import CreateCampaignBox from './components/campaigns/CreateCampaignBox.tsx';
import { CampaignContext } from './contexts/CampaignContext.tsx';
import { MediaTypeId, CheckboxesState, ContentType, ICategory, IEntity, IEntityCount, IMedia, IPackage, IPurpose, IRules, IViewCampaign, Media } from './interfaces/campaign.ts';
import 'swiper/css';
import Detail from './components/studio/Detail.tsx';
import List from './components/studio/List.tsx';
import PreviousOrders from './components/studio/PreviousOrders.tsx';
import PublishedAds from './components/my_tasks/PublishedAds.tsx';
import NewTicket from './components/support/NewTicket.tsx';
import Account from './components/settings/Account.tsx';
import AddBalance from './components/finance/AddBalance.tsx';
import IResponse, { IPagination } from './interfaces/response.ts';
import axios from 'axios';
import { MAX_PACKAGES_PAGE_LIMIT } from './constants/numbers.ts';
import PendingAds from './components/my_tasks/PendingAds.tsx';
import Settlement from './components/finance/settlement/Settlement.tsx';
import dayjs from 'dayjs';
import PaymentListTable from './components/finance/PaymentListTable.tsx';
import ReportListTable from './components/finance/ReportListTable.tsx';
import InvoiceListTable from './components/finance/InvoiceListTable.tsx';
import { UserContext } from './contexts/UserContext.tsx';
import { IGateWay, ITaxPercent } from './interfaces/finance.ts';
import { FinanceContext } from './contexts/FinanceContext.tsx';
import { IUser } from './interfaces/user.ts';
import AdDetails from './components/my_tasks/AdDetails.tsx';
import AdminApp from './AdminApp.tsx';
import AddUser from './components/admin/users/AddUser.tsx';
import SettingAdmin from './components/admin/setting/SettingAdmin.tsx';
import AdminList from './components/admin/users/AdminList.tsx';
import RoleList from './components/admin/roles/RoleList.tsx';
import UserList from './components/admin/users/UserList.tsx';
import { AdapterDateFnsJalali } from '@mui/x-date-pickers/AdapterDateFnsJalaliV3';
import { SidebarProvider } from './contexts/SidebarContext.tsx';
import InvoiceItem from './components/finance/InvoiceItem.tsx';
import MyPages from './components/my_socialMedia/MyPages.tsx';
import ListOfMyPages from './components/my_socialMedia/ListOfMyPages.tsx';
import NewPage from './components/my_socialMedia/NewPage.tsx';
import TicketItem from './components/support/TicketItem.tsx';
import SimilarDetail from './components/studio/SimilarDetail.tsx';
import Cart from './components/finance/Cart.tsx';
import Blogs from './components/admin/blog/Blogs.tsx';
import AdReceivers from './components/admin/users/AdReceivers.tsx';
import AdGivers from './components/admin/users/AdGivers.tsx';
import ProfileGiver from './components/admin/users/ProfileGiver.tsx';
import ProfileReceivers from './components/admin/users/ProfileReceivers.tsx';
import UserProfile from './components/admin/users/profile/UserProfile.tsx';
import Marketers from './components/admin/marketers/Marketers.tsx';
import CategorTable from './components/admin/Tariff/category/CategoryTable.tsx';
import InfluenceralTable from './components/admin/Tariff/Influenceral/InfluenceralTable.tsx';
import TelegramTable from './components/admin/Tariff/Telegram/TelegramTable.tsx';
import EitaTable from './components/admin/Tariff/Eita/EitaTable.tsx';
import RubikaTable from './components/admin/Tariff/Rubika/RubikaTable.tsx';
import WebSiteAdTable from './components/admin/Tariff/WebSiteAd/WebSiteAdTable.tsx';
import CategoryCampagin from './components/admin/campaign/CategoryCampagin.tsx';
import PlatformList from './components/admin/campaign/campaignList/PlatformList.tsx';
import ActiveCampaign from './components/admin/campaign/campaignList/ActiveCampaign.tsx';
import PendPaymentCampaign from './components/admin/campaign/campaignList/PendPaymentCampaign.tsx';
import NotSettlementCampaign from './components/admin/campaign/campaignList/NotSettlementCampaign.tsx';
import CompletedCampaign from './components/admin/campaign/campaignList/CompletedCampaign.tsx';
import TicketAdminItem from './components/admin/ticket/TicketAdminItem.tsx';
import CampaignViewPricing from './components/finance/CampaignViewPricing.tsx';
import { Accounting } from './enum/accounting.tsx';
import CheckPermission from './components/common/CheckPermission.tsx';
import { Campaign } from './enum/campaign.tsx';
import { Option } from './enum/option.tsx';
import { User } from './enum/user.tsx';
import NotFound from './NotFound.tsx';
import AccessPage from './AccessPage.tsx';
import TicketsListAdmin from './components/admin/ticket/TicketsListAdmin.tsx';
import CategoryList from './components/studio/CategoryList.tsx';
import ContentList from './components/studio/ContentList.tsx';
import QualityList from './components/studio/QualityList.tsx';
import PaidRequests from './components/studio/PaidRequests.tsx';
import CurrentRequests from './components/studio/CurrentRequests.tsx';
import Packages from './components/studio/Packages.tsx';
import Management from './components/studio/Management.tsx';
import CreateBlogs from './components/admin/blog/CreateBlog.tsx';
import TicketActiveList from './components/admin/ticket/TicketActiveList.tsx';
import RecommendHour from './components/admin/campaign/RecommendHour.tsx';
import BlockList from '././components/landing/blog/List';
import BlockManage from '././components/landing/blog/Manage';
import PackagesList from './components/admin/campaign/chanelAndPackage/PackageList.tsx';
import AddPackage from './components/admin/campaign/chanelAndPackage/AddPackage.tsx';
import MediaIndex from './components/admin/campaign/media/MediaIndex.tsx';
import NewPackage from './components/studio/package/NewPackage.tsx';
import { Checkout } from './components/finance/Checkout.tsx';
import VeriFyPayment from './components/finance/VeriFyPayment.tsx';
import Axios from './Axios.tsx';
import InstagramTable from './components/admin/Tariff/instagram/instagramTable.tsx';
import BaleTable from './components/admin/Tariff/bale/baleTable.tsx';
import SocialGrowthTable from './components/admin/Tariff/socialGrowth/socialGrowth.tsx';

Sentry.init({
	dsn: 'https://aac758dae31ed210c1179be40789410b@sentry.aban-gostar.ir/2',
	integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
	release: version,
	environment: import.meta.env.VITE_ENVIRONMENT,
	enabled: import.meta.env.PROD,
	// Performance Monitoring
	tracesSampleRate: 1.0, //  Capture 100% of the transactions
	// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
	tracePropagationTargets: ['baran.aban-gostar.ir'],
	// Session Replay
	replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
	replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

ReactDOM.createRoot(document.getElementById('root')!).render(<Root />);

function Root() {
	const searchParams = new URLSearchParams(window.location.search);
	const [theme, setTheme] = useState<PaletteMode>('light');
	const [selectedPlatform, setSelectedPlatform] = useState<Media | null>(searchParams.get('media') as Media);
	const [selectedPlatformId, setSelectedPlatformId] = useState<number | null>(null);
	const [selectedContentType, setSelectedContentType] = useState<ContentType | null>(null);
	const [selectedMediaTypeId, setSelectedMediaTypeId] = useState<MediaTypeId | string | null>(null);
	const [selectedTime, setSelectedTime] = useState<number | null>(null);
	const [selectedDate, setSelectedDate] = useState<dayjs.Dayjs | string | null | Date>(new Date());
	const [typeActiveButton, setTypeActiveButton] = useState(1);
	const [categoryActiveButton, setCategoryActiveButton] = useState(0);
	const [selectedPackages, setSelectedPackages] = useState<any[]>([]);
	const [selectedPages, setSelectedPages] = useState<any[]>([]);
	const [fetchedMedias, setFetchedMedias] = useState<IMedia[]>();
	const [fetchedCategories, setFetchedCategories] = useState<ICategory[]>();
	const [fetchedPurposes, setFetchedPurposes] = useState<IPurpose[]>();
	const [fetchedEntities, setFetchedEntites] = useState<IEntity[] | any>();
	const [fetchedPackages, setFetchedPackages] = useState<IPackage[] | any>();
	const [fetchedGateWays, setFetchedGateWays] = useState<IGateWay[]>();
	const [fetchedEntitiesCount, setFetchedEntitiesCount] = useState<number>(0);
	const [fetchedCampaign, setFetchedCampaign] = useState<IViewCampaign>();
	const [selectedCampaignId, setSelectedCampaignId] = useState<string>();
	const [loadingCampaign, setLoadingCampaign] = useState<boolean>(true);
	const [fetchedRules, setFetchedRules] = useState<IRules>();
	const [fetchedEntitiesPagination, setFetchedEntitiesPagination] = useState<IPagination | null>();
	const [fetchedPackagesPagination, setFetchedPackagesPagination] = useState<IPagination | null>();
	const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(null);
	const [title, setTitle] = useState('');
	const [description, setDescription] = useState('');
	const [selectedPurpose, setSelectedPurpose] = useState<CheckboxesState>({});
	const [contentStatus, setContentStatus] = useState<number | null>(null);
	const [entityPage, setEntityPage] = useState(1);
	const [packagePage, setPackagePage] = useState(1);
	const [userBalance, setUserBalance] = useState<number>();
	const [taxPercent, setTaxPercent] = useState(0);
	const [recoverEmailOrPhone, setRecoverEmailOrPhone] = useState('');
	const [user, setUser] = useState<IUser | null>(null);
	const [permission, setPermissions] = useState<string[] | null>(null);
	const [viewSelectedItemsMode, setViewSelectedItemsMode] = useState<boolean>(false);
	const [savedCampaignId, setSavedCampaignId] = useState<number | null>(null);
	const [IsSerialStory, setIsSerialStory] = useState<boolean>(false);
	const [templateImage, setTemplateImage] = useState<string[]>([]);
	const [sortPackages, setSortPackages] = useState<{ title: string; orderBy: string; orderByDirection: string } | null>(null);

	const isPost = fetchedCampaign ? fetchedCampaign?.content_type === 'post' : selectedContentType === 'post';
	const isStory = fetchedCampaign ? fetchedCampaign?.content_type === 'story' : selectedContentType === 'story';
	const isView = fetchedCampaign ? fetchedCampaign?.media_type_id === 'view' : selectedMediaTypeId === 'view';
	const isReserve = fetchedCampaign ? fetchedCampaign?.media_type_id === 'reserve' : selectedMediaTypeId === 'reserve';
	const isInfluenceral = fetchedCampaign ? fetchedCampaign?.media_type_id === 'influenceral' : selectedMediaTypeId === 'influenceral';
	const fetchedMedia = fetchedCampaign ? fetchedCampaign?.media_id : selectedPlatformId;

	const mediaId = fetchedCampaign?.media_id;
	const mediaTypeId = fetchedCampaign?.media_type_id;
	const mediaEnteties = fetchedCampaign?.entities;
	const mediaEntetyIds = mediaEnteties?.map(ent => ent.id);

	const campaignIndex = Campaign.Index;
	const valuesIndex = Option.ValuesIndex;
	const userIndex = User.UserIndex;
	const userShow = User.UserShow;
	const adminIndex = User.AdminIndex;
	const adminShow = User.AdminShow;
	const roleIndex = User.RoleIndex;
	const transactionIndex = Accounting.PaymentIndex;

	const router = createBrowserRouter([
		{
			path: '/',
			element: <App />,
			children: [
				{
					path: '/admin',
					element: <AdminApp />,
					children: [
						{
							path: 'blog/:id/edit',
							element: <CreateBlogs />,
						},
						{
							path: 'role',
							element: (
								<CheckPermission permissions={roleIndex}>
									<RoleList />
								</CheckPermission>
							),
						},
						{
							path: 'ad_giver',
							element: <AdGivers />,
						},
						{
							path: 'ad_giver/:id',
							element: <ProfileGiver />,
						},
						{
							path: 'ad_reciever',
							element: <AdReceivers />,
						},
						{
							path: 'ad_reciever/:id',
							element: <ProfileReceivers />,
						},
						{
							path: 'settings/site-setting',
							element: <SettingAdmin />,
						},
						{
							path: 'user',
							element: (
								<CheckPermission permissions={userIndex}>
									<UserList />
								</CheckPermission>
							),
						},
						{
							path: 'users/:id',
							element: (
								<CheckPermission permissions={userShow}>
									<UserProfile />
								</CheckPermission>
							),
						},
						{
							path: 'admin',
							element: (
								<CheckPermission permissions={adminIndex}>
									<AdminList />
								</CheckPermission>
							),
						},
						{
							path: 'admin/:id',
							element: (
								<CheckPermission permissions={adminShow}>
									<UserProfile />,
								</CheckPermission>
							),
						},
						{
							path: ':type/new',
							element: <AddUser />,
						},
						{
							path: ':type/:id/edit',
							element: <AddUser />,
						},
						{
							path: 'blog',
							element: <Blogs />,
						},
						{
							path: 'blog/create',
							element: (
								<div className={'w-auto'}>
									<CreateBlogs />
								</div>
							),
						},
						// {
						// 	path: 'my-companies/:id',
						// 	element: <Company />,
						// },
						{
							path: 'view/:id',
							element: <ViewCampaign is_Admin={true} />,
						},
						{
							path: 'marketers',
							element: <Marketers />,
						},
						{
							path: 'support/view/:id',
							element: <TicketAdminItem />,
						},

						{
							path: 'tickets/list',
							element: <TicketsListAdmin />,
						},
						{
							path: '/admin/tickets/active/list',
							element: <TicketActiveList />,
						},
						{
							path: '/admin/studio/category/manage',
							element: <CategoryList />,
						},
						{
							path: '/admin/studio/content',
							element: <ContentList />,
						},
						{
							path: '/admin/studio/qualit',
							element: <QualityList />,
						},
						{
							path: '/admin/studio/package/new',
							element: <NewPackage />,
						},
						{
							path: 'studio/package/edit/:id',
							element: <NewPackage />,
						},
						{
							path: '/admin/studio/management',
							element: <Management />,
						},
						{
							path: '/admin/studio/requested',
							element: <CurrentRequests />,
						},
						{
							path: '/admin/studio/paid',
							element: <PaidRequests />,
						},
						{
							path: '/admin/studio/design',
							element: <BlockList isStodio={true} />, //
						},
						{
							path: '/admin/studio/package',
							element: <Packages />,
						},
					],
				},
				{
					path: '/tariff',
					element: <AdminApp />,
					children: [
						{
							path: 'category',
							element: <CategorTable />,
						},
						{
							path: 'influencers',
							element: <InfluenceralTable />,
						},
						{
							path: 'telegram-groups',
							element: <TelegramTable />,
						},
						{
							path: 'instagram-pages',
							element: <InstagramTable />,
						},
						{
							path: 'bale-chanels',
							element: <BaleTable />,
						},
						{
							path: 'social-growth',
							element: <SocialGrowthTable />,
						},
						{
							path: 'eita-groups',
							element: <EitaTable />,
						},
						{
							path: 'rubika-groups',
							element: <RubikaTable />,
						},
						{
							path: 'websites',
							element: <WebSiteAdTable />,
						},
						{
							path: ':type/new',
							element: <AddUser />,
						},
						{
							path: ':type/:id/edit',
							element: <AddUser />,
						},
						{
							path: 'tickets/list',
							element: <NewTicket />,
						},
						{
							path: 'tickets/active/list',
							element: <TicketsList />,
						},
					],
				},
				{
					path: 'campaigns',
					children: [
						{
							path: 'category',
							element: (
								<CheckPermission permissions={valuesIndex} isPage>
									<CategoryCampagin />,
								</CheckPermission>
							),
						},
						{
							path: 'list',
							element: (
								<CheckPermission permissions={campaignIndex} isPage>
									<PlatformList />,
								</CheckPermission>
							),
						},
						{
							path: 'active',
							element: (
								<CheckPermission permissions={campaignIndex} isPage>
									<ActiveCampaign />,
								</CheckPermission>
							),
						},
						{
							path: 'pending',
							element: (
								<CheckPermission permissions={campaignIndex} isPage>
									<PendPaymentCampaign />,
								</CheckPermission>
							),
						},
						{
							path: 'completed',
							element: (
								<CheckPermission permissions={campaignIndex} isPage>
									<CompletedCampaign />,
								</CheckPermission>
							),
						},
						{
							path: 'unsettled',
							element: (
								<CheckPermission permissions={campaignIndex} isPage>
									<NotSettlementCampaign />,
								</CheckPermission>
							),
						},
						{
							path: 'recommend_hour',
							element: <RecommendHour />,
						},
						{
							path: 'medias',
							element: <MediaIndex />,
						},
						{
							path: 'chanels',
							element: <PackagesList />,
						},
						{
							path: 'add_chanels',
							element: <AddPackage />,
						},
						{
							path: 'add_chanels/:id',
							element: <AddPackage />,
						},
					],
				},
				{
					path: '/',
					element: <Dashboard />,
				},
				{
					path: 'dashboard',
					element: <Dashboard />,
				},
				{
					path: 'campaigns',
					children: [
						{
							path: '',
							element: <ManageCampaign />,
						},
						{
							path: 'create',
							element: <CreateCampaign />,
						},
						{
							path: 'view/:id',
							element: <ViewCampaign />,
						},
						{
							path: 'create/:type',
							element: <CreateCampaignBox />,
						},
						{
							path: 'ordered-ad',
							element: <MyPages title="ordered_ad_header_message" type="ordered-ad" />,
						},
					],
				},
				{
					path: 'my-social-media',
					children: [
						{
							path: 'list-of-my-pages',
							element: <ListOfMyPages />,
						},
						{
							path: 'new',
							element: <NewPage isCreate={true} />,
						},
						{
							path: 'edit/:id',
							element: <NewPage isCreate={false} />,
						},
					],
				},
				{
					path: 'my-tasks',
					children: [
						{
							path: 'pending/ads',
							element: <PendingAds />,
						},
						{
							path: 'details/:id',
							element: <AdDetails />,
						},
						{
							path: 'published-ads',
							element: <PublishedAds />,
						},
						{
							path: 'received-ad',
							element: <MyPages title="received_ad_header_message" type="received-ad" />,
						},
					],
				},
				{
					path: 'studio',
					children: [
						{
							path: ':type/:id',
							element: <Studio />,
							loader: studioLoader,
						},
						{
							path: 'detail/:id',
							children: [
								{
									index: true,
									element: <Detail />,
								},
								{
									path: 'similar',
									element: <SimilarDetail />,
								},
							],
						},
						{
							index: true,
							element: <List />,
						},
						{
							path: 'previous-orders',
							element: <PreviousOrders />,
						},
					],
				},
				{
					path: 'finance',
					children: [
						{
							path: 'cart',
							element: <Cart />,
						},
						{
							path: 'add-balance',
							element: <AddBalance />,
						},
						{
							path: 'checkout',
							element: <Checkout />,
						},
						{
							path: 'settlement',
							element: <Settlement />,
						},
						{ path: 'reports', element: <ReportListTable /> },
						{
							path: 'payments',
							element: (
								<CheckPermission permissions={transactionIndex} isPage>
									<PaymentListTable />,
								</CheckPermission>
							),
						},
						{
							path: 'payment/ongoingcampaigns',
							element: <ManageCampaign />,
						},
						{
							path: 'payment/campaignslist',
							element: <ManageCampaign />,
						},
						{
							path: 'media/:type',
							element: <CampaignViewPricing />,
						},
						{
							path: 'invoices',
							children: [
								{
									index: true,
									element: <InvoiceListTable />,
								},
								{
									path: ':id',
									element: <InvoiceItem />,
								},
							],
						},
					],
				},
				{
					path: 'support',
					children: [
						{
							path: 'new-ticket',
							element: <NewTicket />,
						},
						{
							path: 'tickets-list',
							element: <TicketsList />,
						},
						{
							path: 'view/:id',
							element: <TicketItem />,
						},
					],
				},
				{
					path: 'settings',
					children: [
						// {
						// 	path: 'my-companies',
						// 	element: <MyCompanies />,
						// },
						{
							path: 'user-account',
							element: <Account />,
						},
						// {
						// 	path: 'my-companies/:id',
						// 	element: <Company />,
						// },
					],
				},
				{
					path: 'help',
					element: <Help />,
				},
				{
					path: 'block',
					children: [
						{
							path: 'list',
							element: <BlockList />,
						},
						{
							path: 'create',
							element: <BlockManage />,
						},
						{
							path: 'edit/:id',
							element: <BlockManage />,
						},
					],
				},
				{
					path: 'handle-studios',
					children: [
						{
							path: 'create',
							element: <BlockManage isStodio={true} />,
						},
						{
							path: 'edit/:id',
							element: <BlockManage isStodio={true} />,
						},
					],
				},
			],
		},
		{
			path: '/auth',
			element: <Auth />,
			loader: async () => {
				const isLogged = await localStorage.getItem('token');
				if (isLogged !== null) {
					return redirect('/');
				} else {
					return <Auth />;
				}
			},
			children: [
				{
					path: 'login',
					element: <Login />,
				},
				{
					path: 'register',
					element: <Register />,
				},
				{
					path: 'recover-password',
					element: <ResetPassword />,
				},
				{
					path: 'confirm-code',
					element: <ConfirmCode />,
				},
				{
					path: 'set-new-password',
					element: <NewPassword />,
				},
			],
		},
		{
			path: '*',
			element: <NotFound />,
		},
		{
			path: 'verify-payment/:id',
			element: <VeriFyPayment />,
		},
		{
			path: '/access',
			element: <AccessPage />,
		},
	]);

	const resetAllFields = () => {
		setSelectedPlatform(null);
		setSelectedPlatformId(null);
		setSelectedContentType(null);
		setSelectedMediaTypeId(null);
		setSelectedTime(null);
		setSelectedDate(new Date());
		setTypeActiveButton(1);
		setCategoryActiveButton(0);
		setSelectedPackages([]);
		setSelectedPages([]);
		setSelectedCampaignId('');
		setLoadingCampaign(true);
		setSavedCampaignId(null);
		setSelectedCategoryId(null);
		setTitle('');
		setDescription('');
		setSelectedPurpose({});
		setContentStatus(null);
		setEntityPage(1);
		setPackagePage(1);
	};

	// useEffect(() => {
	// 	const params = {
	// 		page: entityPage.toString(),
	// 		limit: MAX_PACKAGES_PAGE_LIMIT.toString(),
	// 		media_id: selectedPlatformId?.toString(),
	// 		searchTerm: '',
	// 	};

	// 	axios<IResponse<IEntity[]>>({
	// 		url: '/media_entities',
	// 		params: params,
	// 	}).then(res => {
	// 		if (res.data.success) {
	// 			setFetchedEntitiesPagination(res.data.pagination);
	// 			setFetchedEntites(res.data.data);
	// 		}
	// 	});
	// }, [entityPage, selectedPlatformId]);

	useEffect(() => {
		const params = {
			page: packagePage.toString(),
			limit: MAX_PACKAGES_PAGE_LIMIT.toString(),
			media_id: selectedPlatformId?.toString(),
			searchTerm: '',
		};

		axios<IResponse<IPackage>>({
			url: '/media_packages',
			params: params,
		}).then(res => {
			if (res.data.success) {
				setFetchedPackagesPagination(res.data.pagination);
				setFetchedPackages(res.data.data);
			}
		});
	}, [packagePage, selectedPlatformId]);

	useEffect(() => {
		if (!fetchedCampaign) {
			return;
		}

		const params: {
			media_id?: number;
			media_type_id?: string;
			media_entity_ids?: string;
		} = {};

		if (mediaId) {
			params.media_id = mediaId;
		}

		if (mediaTypeId) {
			params.media_type_id = mediaTypeId.toString();
		}

		if (mediaEntetyIds) {
			params.media_entity_ids = JSON.stringify(mediaEntetyIds);
		}

		axios<IResponse<IRules>>({
			url: 'campaigns/rules',
			params: params,
		}).then(res => {
			if (res.data.success) {
				setFetchedRules(res.data.data);
			}
		});
	}, [fetchedCampaign]);

	// useEffect(() => {
	// 	if (!selectedCampaignId) {
	// 		return;
	// 	}

	// 	setLoadingCampaign(true);
	// 	axios<IResponse<IViewCampaign>>({
	// 		url: `/campaigns/${selectedCampaignId}`,
	// 	})
	// 		.then(res => {
	// 			if (res.data.success) {
	// 				setFetchedCampaign(res.data.data);
	// 			}
	// 		})
	// 		.finally(() => {
	// 			setLoadingCampaign(false);
	// 		});
	// }, [selectedCampaignId]);

	useEffect(() => {
		const params: {
			is_post?: string;
			is_story?: string;
			view_campaign?: string;
			reserve_campaign?: string;
			influencer_campaign?: string;
			media_id?: number;
		} = {};

		if (isPost) {
			params.is_post = '1';
		} else if (isStory) {
			params.is_story = '1';
		}

		if (isView) {
			params.view_campaign = '1';
		} else if (isReserve) {
			params.reserve_campaign = '1';
		} else if (isInfluenceral) {
			params.influencer_campaign = '1';
		}

		if (fetchedMedia) {
			params.media_id = fetchedMedia;
		}

		axios<IResponse<IEntityCount>>({
			url: '/media_entities/count',
			params: params,
		}).then(res => {
			if (res.data.success) {
				setFetchedEntitiesCount(res.data.data.count);
			}
		});
	}, [selectedMediaTypeId, selectedContentType, selectedPlatform, fetchedCampaign]);

	useEffect(() => {
		const now = Date.now();
		const expireTimeString = localStorage.getItem('expireTime');

		let expireTime: number | null = null;
		if (expireTimeString) {
			try {
				expireTime = JSON.parse(expireTimeString);
			} catch (e) {
				console.error('Error parsing expireTime from localStorage:', e);
			}
		}

		if (!expireTime || expireTime < now) {
			localStorage.removeItem('token');
			localStorage.removeItem('expireTime');
		}
	}, []);

	useEffect(() => {
		axios<IResponse<ITaxPercent>>({
			url: '/settings/tax_percent',
		}).then(res => {
			if (res.data.success) {
				setTaxPercent(res.data.data.tax_percent);
			}
		});
		axios<IResponse<IGateWay[]>>({
			url: '/gateways',
		}).then(res => {
			if (res.data.success) {
				setFetchedGateWays(res.data.data);
			}
		});
	}, []);

	useEffect(() => {
		const style = document.createElement('style');
		const colors = palettes[theme];

		style.innerHTML = `
            :root {
              --color-primary-main: ${colors.primary.main};
              --color-primary-dark: ${colors.primary.dark};
              --color-primary-light: ${colors.primary.light};
              --color-primary-contrastText: ${colors.primary.contrastText};
              --color-primary-50: ${colors.primary[50]};
              --color-primary-100: ${colors.primary[100]};
              --color-primary-200: ${colors.primary[200]};
              --color-primary-300: ${colors.primary[300]};
              --color-primary-400: ${colors.primary[400]};
              --color-primary-500: ${colors.primary[500]};
              --color-primary-600: ${colors.primary[600]};
              --color-primary-700: ${colors.primary[700]};
              --color-primary-800: ${colors.primary[800]};
              --color-primary-900: ${colors.primary[900]};
              --color-primary-A100: ${colors.primary.A100};
              --color-primary-A200: ${colors.primary.A200};
              --color-primary-A400: ${colors.primary.A400};
              --color-primary-A700: ${colors.primary.A700};
          
              --color-secondary-main: ${colors.secondary.main};
              --color-secondary-dark: ${colors.secondary.dark};
              --color-secondary-light: ${colors.secondary.light};
              --color-secondary-contrastText: ${colors.secondary.contrastText};
              --color-secondary-50: ${colors.secondary[50]};
              --color-secondary-100: ${colors.secondary[100]};
              --color-secondary-200: ${colors.secondary[200]};
              --color-secondary-300: ${colors.secondary[300]};
              --color-secondary-400: ${colors.secondary[400]};
              --color-secondary-500: ${colors.secondary[500]};
              --color-secondary-600: ${colors.secondary[600]};
              --color-secondary-700: ${colors.secondary[700]};
              --color-secondary-800: ${colors.secondary[800]};
              --color-secondary-900: ${colors.secondary[900]};
              --color-secondary-A100: ${colors.secondary.A100};
              --color-secondary-A200: ${colors.secondary.A200};
              --color-secondary-A400: ${colors.secondary.A400};
              --color-secondary-A700: ${colors.secondary.A700};
          
              --color-error-main: ${colors.error.main};
              --color-error-dark: ${colors.error.dark};
              --color-error-light: ${colors.error.light};
              --color-error-contrastText: ${colors.error.contrastText};
              --color-error-50: ${colors.error[50]};
              --color-error-100: ${colors.error[100]};
              --color-error-200: ${colors.error[200]};
              --color-error-300: ${colors.error[300]};
              --color-error-400: ${colors.error[400]};
              --color-error-500: ${colors.error[500]};
              --color-error-600: ${colors.error[600]};
              --color-error-700: ${colors.error[700]};
              --color-error-800: ${colors.error[800]};
              --color-error-900: ${colors.error[900]};
              --color-error-A100: ${colors.error.A100};
              --color-error-A200: ${colors.error.A200};
              --color-error-A400: ${colors.error.A400};
              --color-error-A700: ${colors.error.A700};
          
              --color-warning-main: ${colors.warning.main};
              --color-warning-dark: ${colors.warning.dark};
              --color-warning-light: ${colors.warning.light};
              --color-warning-contrastText: ${colors.warning.contrastText};
              --color-warning-50: ${colors.warning[50]};
              --color-warning-100: ${colors.warning[100]};
              --color-warning-200: ${colors.warning[200]};
              --color-warning-300: ${colors.warning[300]};
              --color-warning-400: ${colors.warning[400]};
              --color-warning-500: ${colors.warning[500]};
              --color-warning-600: ${colors.warning[600]};
              --color-warning-700: ${colors.warning[700]};
              --color-warning-800: ${colors.warning[800]};
              --color-warning-900: ${colors.warning[900]};
              --color-warning-A100: ${colors.warning.A100};
              --color-warning-A200: ${colors.warning.A200};
              --color-warning-A400: ${colors.warning.A400};
              --color-warning-A700: ${colors.warning.A700};
          
              --color-success-main: ${colors.success.main};
              --color-success-dark: ${colors.success.dark};
              --color-success-light: ${colors.success.light};
              --color-success-contrastText: ${colors.success.contrastText};
              --color-success-50: ${colors.success[50]};
              --color-success-100: ${colors.success[100]};
              --color-success-200: ${colors.success[200]};
              --color-success-300: ${colors.success[300]};
              --color-success-400: ${colors.success[400]};
              --color-success-500: ${colors.success[500]};
              --color-success-600: ${colors.success[600]};
              --color-success-700: ${colors.success[700]};
              --color-success-800: ${colors.success[800]};
              --color-success-900: ${colors.success[900]};
              --color-success-A100: ${colors.success.A100};
              --color-success-A200: ${colors.success.A200};
              --color-success-A400: ${colors.success.A400};
              --color-success-A700: ${colors.success.A700};
          
              --color-info-main: ${colors.info.main};
              --color-info-dark: ${colors.info.dark};
              --color-info-light: ${colors.info.light};
              --color-info-contrastText: ${colors.info.contrastText};
              --color-info-50: ${colors.info[50]};
              --color-info-100: ${colors.info[100]};
              --color-info-200: ${colors.info[200]};
              --color-info-300: ${colors.info[300]};
              --color-info-400: ${colors.info[400]};
              --color-info-500: ${colors.info[500]};
              --color-info-600: ${colors.info[600]};
              --color-info-700: ${colors.info[700]};
              --color-info-800: ${colors.info[800]};
              --color-info-900: ${colors.info[900]};
              --color-info-A100: ${colors.info.A100};
              --color-info-A200: ${colors.info.A200};
              --color-info-A400: ${colors.info.A400};
              --color-info-A700: ${colors.info.A700};
          
              --color-grey-50: ${colors.grey[50]};
              --color-grey-100: ${colors.grey[100]};
              --color-grey-200: ${colors.grey[200]};
              --color-grey-300: ${colors.grey[300]};
              --color-grey-400: ${colors.grey[400]};
              --color-grey-500: ${colors.grey[500]};
              --color-grey-600: ${colors.grey[600]};
              --color-grey-700: ${colors.grey[700]};
              --color-grey-800: ${colors.grey[800]};
              --color-grey-900: ${colors.grey[900]};
              --color-grey-A100: ${colors.grey.A100};
              --color-grey-A200: ${colors.grey.A200};
              --color-grey-A400: ${colors.grey.A400};
              --color-grey-A700: ${colors.grey.A700};

              --color-orange-main: ${colors.orange.main};
			        --color-orange-50: ${colors.orange[50]};
              --color-orange-100: ${colors.orange[100]};
              --color-orange-200: ${colors.orange[200]};
              --color-orange-300: ${colors.orange[300]};
              --color-orange-400: ${colors.orange[400]};
              --color-orange-500: ${colors.orange[500]};
              --color-orange-600: ${colors.orange[600]};
              --color-orange-700: ${colors.orange[700]};
              --color-orange-800: ${colors.orange[800]};
              --color-orange-900: ${colors.orange[900]};

              --color-green-main: ${colors.green.main};
			        --color-green-50: ${colors.green[50]};
              --color-green-100: ${colors.green[100]};
              --color-green-200: ${colors.green[200]};
              --color-green-300: ${colors.green[300]};
              --color-green-400: ${colors.green[400]};
              --color-green-500: ${colors.green[500]};
              --color-green-600: ${colors.green[600]};
              --color-green-700: ${colors.green[700]};
              --color-green-800: ${colors.green[800]};
              --color-green-900: ${colors.green[900]};
          
              --color-text-primary: ${colors.text.primary};
              --color-text-secondary: ${colors.text.secondary};
              --color-text-disabled: ${colors.text.disabled};
          
              --color-background-default: ${colors.background.default};
              --color-background-paper: ${colors.background.paper};
          
              --color-action-active: ${colors.action.active};
              --color-action-hover: ${colors.action.hover};
              --color-action-selected: ${colors.action.selected};
              --color-action-disabled: ${colors.action.disabled};
              --color-action-disabledBackground: ${colors.action.disabledBackground};
              --color-action-focus: ${colors.action.focus};
              --color-action-hoverOpacity: ${colors.action.hoverOpacity};
              --color-action-disabledOpacity: ${colors.action.disabledOpacity};
            }
          `;

		document.head.appendChild(style);
		return () => {
			document.head.removeChild(style);
		};
	}, [theme]);
	return (
		<ThemeContext.Provider value={{ theme, setTheme }}>
			<ThemeProvider theme={useProjectTheme(theme)}>
				<UserContext.Provider value={{ user, userBalance, recoverEmailOrPhone, permission, setPermissions, setUserBalance, setRecoverEmailOrPhone, setUser }}>
					<FinanceContext.Provider value={{ taxPercent, fetchedGateWays }}>
						<CampaignContext.Provider
							value={{
								savedCampaignId,
								viewSelectedItemsMode,
								contentStatus,
								selectedPurpose,
								description,
								title,
								selectedCategoryId,
								packagePage,
								entityPage,
								fetchedEntitiesPagination,
								fetchedPackagesPagination,
								fetchedRules,
								loadingCampaign,
								selectedCampaignId,
								fetchedCampaign,
								fetchedEntitiesCount,
								fetchedPackages,
								fetchedEntities,
								selectedPlatformId,
								fetchedPurposes,
								fetchedCategories,
								fetchedMedias,
								selectedPackages,
								selectedPages,
								selectedPlatform,
								selectedContentType,
								selectedMediaTypeId,
								selectedDate,
								selectedTime,
								typeActiveButton,
								categoryActiveButton,
								IsSerialStory,
								templateImage,
								sortPackages,
								setSortPackages,
								setTemplateImage,
								setIsSerialStory,
								setViewSelectedItemsMode,
								setFetchedCampaign,
								setSelectedPackages,
								setSelectedPages,
								setTypeActiveButton,
								setCategoryActiveButton,
								setSelectedDate,
								setSelectedTime,
								setSelectedPlatform,
								setSelectedContentType,
								setSelectedMediaTypeId,
								setSelectedPlatformId,
								setSelectedCampaignId,
								setLoadingCampaign,
								setFetchedRules,
								setFetchedEntitiesPagination,
								setFetchedEntites,
								setEntityPage,
								setPackagePage,
								setFetchedPackages,
								setFetchedPackagesPagination,
								setSelectedCategoryId,
								setTitle,
								setDescription,
								setSelectedPurpose,
								setContentStatus,
								resetAllFields,
								setFetchedCategories,
								setFetchedMedias,
								setFetchedPurposes,
								setSavedCampaignId,
							}}
						>
							<SidebarProvider>
								<LocalizationProvider dateAdapter={AdapterDateFnsJalali}>
									<React.StrictMode>
										<RTL>
											<Axios />
											<RouterProvider router={router} />
										</RTL>
									</React.StrictMode>
								</LocalizationProvider>
							</SidebarProvider>
						</CampaignContext.Provider>
					</FinanceContext.Provider>
				</UserContext.Provider>
			</ThemeProvider>
		</ThemeContext.Provider>
	);
}
